export const keys = (ob) => {
  if (!ob) return [];

  return Object.keys(ob);
};

export const values = (ob) => {
  if (!ob) return [];

  return Object.values(ob);
};

export const isDeepEqual = (object1, object2) => JSON.stringify(object1) === JSON.stringify(object2);
